import "../styles/cgu.scss"

function Confidentialite(){

return(

    <div className="blocpage">
        <h1>POLITIQUE DE CONFIDENTIALITÉ</h1>

<h2>1. Responsable du traitement</h2>
<h3>Les données sont collectées par :</h3>
<p>
BMDev
Micro-entreprise<br></br>
SIRET : 9409122490001<br></br>
1 rue du soleil levant, 92140 Clamart<br></br>
Email : briconnectapp@gmail.com
</p>

<h2>2. Données collectées</h2>

<h3>Nous collectons :</h3>
<p>
• Nom et prénom<br></br>
• Adresse email<br></br>
• Numéro de téléphone<br></br>
• Adresse / localisation<br></br>
• Informations professionnelles (pour les Pros : SIRET, activité)<br></br>
• Messages échangés via la plateforme
</p>

<h2>3. Finalité de la collecte</h2>

<h3>Les données sont utilisées pour :</h3>
<p>
• Créer et gérer les comptes utilisateurs<br></br>
• Permettre la mise en relation<br></br>
• Gérer les abonnements<br></br>
• Améliorer le service<br></br>
</p>

<h2>4. Base légale</h2>

<h3>Le traitement repose sur :</h3>
<p>
• L’exécution du contrat (CGU)<br></br>
• L’intérêt légitime de fonctionnement de la plateforme
</p>

<h2>5. Conservation des données</h2>

<h3>Les données sont conservées :</h3>
<p>
• Pendant la durée d’utilisation du compte<br></br>
• Puis 3 ans après la suppression du compte
</p>

<h2>6. Partage des données</h2>
<p>
Les données ne sont ni vendues ni cédées.<br></br>
Certaines données peuvent être partagées avec :<br></br>
• Le prestataire de paiement (ex : Stripe)<br></br>
• L’hébergeur technique
</p>

<h2>7. Droits des utilisateurs</h2>
<p>
Conformément au RGPD, vous disposez :<br></br>
• D’un droit d’accès<br></br>
• D’un droit de rectification<br></br>
• D’un droit de suppression<br></br>
• D’un droit d’opposition<br></br>
Toute demande peut être adressée à : briconnectapp@gmail.fr
</p>

<h2>8. Sécurité des données</h2>
<p>
Nous mettons en œuvre des mesures techniques et organisationnelles appropriées afin de garantir la sécurité des données personnelles et d’empêcher leur accès, divulgation ou modification non autorisés.
</p>

<h2>9. Paiements</h2>
<p>
    Les paiements sont sécurisés et traités par un prestataire tiers (Stripe).
Nous ne stockons aucune donnée bancaire.
</p>

   <h2>10. Hébergement</h2>
   <p>
Les données sont hébergées par :<br></br>
Vercel Inc.<br></br>
440 N Barranca Ave #4133<br />
Covina, CA 91723<br />
États-Unis<br />
Site web : https://vercel.com 
  </p>

  <h2>11. Cookies</h2>
  <p>
Le site peut utiliser des cookies afin d’améliorer l’expérience utilisateur et mesurer l’audience.
L’utilisateur peut configurer ses préférences via son navigateur.
</p>
    </div>
)
}

export default Confidentialite